import { useSuspenseQuery } from '@tanstack/react-query';
import type { GoToTest } from '../types';
import queryKeys from './queryKeys';
import type { QueryConfig } from 'lib/react-query';
import type { ListResponse, SortingParams } from 'types/shared';
import { apiClient } from 'lib/api';
import queryString from 'query-string';

interface GetParams extends Partial<SortingParams> {
  name?: string;
  apps?: string[];
  limit?: number;
  offset?: number;
}

export const getGoToTest = async (
  params?: GetParams,
  signal?: AbortSignal,
): Promise<ListResponse<GoToTest>> => {
  const res = await apiClient.get<ListResponse<GoToTest>>(queryKeys.goToTest, {
    signal,
    params,
    paramsSerializer: (prms) =>
      queryString.stringify(prms, { arrayFormat: 'comma' }),
  });
  return res.data;
};

interface UseOptions<TData> {
  config?: QueryConfig<typeof getGoToTest, TData>;
  params?: GetParams;
}

export const useGoToTest = <TData = ListResponse<GoToTest>>
({
   config,
   params,
 }: UseOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getGoToTest(params, signal),
    queryKey: [queryKeys.goToTest, params],
  });
};
